import { createBrowserRouter, type RouteObject } from 'react-router-dom';

// import { Dashboard } from '@/app/modules/dashboard';
import { Products } from '@/app/modules/products';
import { Stips } from '@/app/modules/stips';
import { DocumentsRedirect } from '@/app/modules/stips/DocumentsRedirect';
import { StipsFinalPage } from '@/app/modules/stipsFinalPage';
import UploadStips from '@/app/modules/uploadStips/UploadStips';
import App from '../../../App';
import { Auth } from '../../modules/auth';
import { Error } from '../../modules/error';
// import { Home } from '../../modules/home';
import { NotFound } from '../../modules/notfound';
import { Profile } from '../../modules/profile';
import { ProtectedRoute } from './ProtectedRoute';

export const routes: RouteObject[] = [
  // Public Routes
  {
    path: '/login',
    element: <Auth />,
  },

  // Protected App Layout
  {
    path: '/',
    element: (
      <ProtectedRoute
        element={<App />}
      />
    ),

    errorElement: <Error />,

    children: [
      // {
      //   index: true,
      //   element: <Dashboard />,
      // },

      {
        index: true,
        element: <DocumentsRedirect />,
      },

      {
        path: 'profile',
        element: <Profile />,
      },

      {
        path: 'documents',
        element: <Stips />,
      },

      {
        path: 'products',
        element: <Products />,
      },

      {
        path: 'upload',
        element: <UploadStips />,
      },

      {
        path: 'final',
        element: <StipsFinalPage />,
      },

      {
        path: 'error',
        element: <Error />,
      },

      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes);